const uiConfig = {
  info: {
    languages: [
      { code: "en", langCode: "en", title: "English", imgPath: "" },
      { code: "es", langCode: "es-es", title: "ESPAÑOL", imgPath: "" },
      { code: "ru", langCode: "ru-ru", title: "РУССКИЙ", imgPath: "" },
      { code: "ch", langCode: "de-de", title: "DEUTSCH", imgPath: "" },
      { code: "fr", langCode: "fr-fr", title: "Français", imgPath: "" },
      { code: "sa", langCode: "ar-sa", title: "عربي", imgPath: "" },
      { code: "ir", langCode: "fa-ir", title: "فارسی", imgPath: "" },
      { code: "ko", langCode: "ko-kr", title: "한글", imgPath: "" },

      { code: "tr", langCode: "tr-tr", title: "Türkçe", imgPath: "" },
      { code: "pt", langCode: "pt-pt", title: "PORTUGUÊS", imgPath: "" },
      { code: "pl", langCode: "pl-pl", title: "POLSKI", imgPath: "" },
      { code: "jp", langCode: "ja-jp", title: "日本語", imgPath: "" }, // shall use country code. Example: zh-hk, zh-cn and zh-tw. Shall be hk and cn
      { code: "my", langCode: "ms-my", title: "MALAY", imgPath: "" },
      { code: "kz", langCode: "kk-kz", title: "қазақша", imgPath: "" },
    ],
  },
  defaultLangCode: "en",
  isCash: false,
  isSoundEnabled: false,
  isInvitationEnabled: true,
  isEnabledKYC: false,
  loginPage: {
    isSkipLoginVideo: false,
    isEnableConfirmPassword: true,
    isSkipEmail: false,
  },
  grabOrderPage: {
    isAccountBalanceFirst: false,
    progressNotes: {
      progressNote2: "",
      progressNote3: "",
      progressNote4: "",
    },
    isEnabledProductSlider: true,
  },
  bindWalletSettings: {
    isUSDTWallet: true,
  },
  bindBankAccSettings: {
    isShowBankCode: false,
  },
  isDepositReqEnabled: false,
};
window.uiConfig = uiConfig;
export default uiConfig;
